import { render, staticRenderFns } from "./SeviceRatio.vue?vue&type=template&id=3e6e2401&"
import script from "./SeviceRatio.vue?vue&type=script&lang=js&"
export * from "./SeviceRatio.vue?vue&type=script&lang=js&"
import style0 from "./SeviceRatio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports